<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Nova Categoria</h3>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-6">
                            <label for="name">Nome</label>
                            <input type="text" class="form-control" name="name" v-model="materialCategory.name" id="name">
                        </div>

                        <div class="col-md-6 m-t-sm">
                            <label for="photo">Imagem da Categoria</label>
                            <input type="file" name="photo" id="photo">
                            <img class="m-t-lg" width="50%" :src="materialCategory.photo">
                        </div>
                    </div>
                    <hr>
                    <a class="btn btn-success" @click="save">Salvar</a>
                    <router-link to="/materialCategory" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                materialCategory: {
                    name: '',
                },
                errors: undefined
            }
        },
        methods: {
            save: function () {
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'materialCategory';

                let form = new FormData();
                let photo = document.getElementById('photo');

                photo     = (photo.files[0]) ? photo.files[0] : '';

                form.append('name', this.materialCategory.name);
                form.append('photo', photo);

                self.$http.post(api + '/' + id, form)
                    .then((response) => {
                        self.materialCategories = response.data;
                        self.tableData = self.materialCategories;

                        self.$message('Sucesso', `Categoria atualizada com sucesso`, 'success');

                        self.materialCategory = response.data;

                        photo.value = '';
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li class="m-t-sm m-b-sm">' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    })
            }
        },
        mounted: function(){
            const self = this;
            const id   = self.$route.params.id;
            const api  = self.$store.state.api;

            self.$http.get(api + 'materialCategory/' + id)
                .then((response) => {
                    self.materialCategory = response.data;
                });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>


</style>



// WEBPACK FOOTER //
// src/components/MaterialCategory/Edit.vue